<template>
  <div class="table-container">
    <div class="h1">{{t('enum.text_18')}}</div>
    <div class="sr-container__content sr-container__content--row">
      <el-form :model="formReq.fields" inline :label-width="localCN?'120px':'170px'" label-position="left">
        <el-form-item :label="formReq.schema.acctName.label">
          <el-input v-model="formReq.fields.acctName" :placeholder="formReq.schema.acctName.placeholder" />
        </el-form-item>

        <el-form-item :label="formReq.schema.acctId.label">
          <el-input v-model="formReq.fields.acctId" :placeholder="formReq.schema.acctId.placeholder" />
        </el-form-item>
        <el-form-item :label="formReq.schema.inviteCode.label">
          <el-input v-model="formReq.fields.inviteCode" :placeholder="formReq.schema.inviteCode.placeholder" />
        </el-form-item>

        <el-form-item :label="formReq.schema.acctStat.label">
          <el-select v-model="formReq.fields.acctStat" clearable :placeholder="formReq.schema.acctStat.placeholder">
            <el-option v-for="(value,key) in acctStatEnum" :key="key" :label="value" :value="key" />
          </el-select>
        </el-form-item>

        <el-form-item :label="formReq.schema.regDate.label">
          <el-date-picker
              v-model="formReq.fields.regDate"
              type="daterange"
              unlink-panels
              range-separator="-"
              value-format="YYYY-MM-DD"
              :start-placeholder="t('components.datepicker.start')"
              :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="formReq.schema.incomeDate.label">
          <el-date-picker
              v-model="formReq.fields.incomeDate"
              type="daterange"
              unlink-panels
              range-separator="-"
              value-format="YYYY-MM-DD"
              :start-placeholder="t('components.datepicker.start')"
              :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">{{t('client.content.text_1')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadList">{{t('client.content.text_6')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table row-class-name="row-con" :data="tbl.data.list" v-loading="tbl.data.loading">
      <sr-tbl-column :columns="tbl.columns">
        <template #acctId="scope">
          <div>
            <div>{{scope.row.acctName}}</div>
            <div>{{scope.row.acctId}}</div>
          </div>
        </template>
        <template #collectionAcct="scope">
          <div class="header-cell">
            <el-button type="primary" text @click="checkAccount(scope.row)">{{t('global.content.text_9')}}</el-button>
          </div>
        </template>
        <template #acctStat="scope">
          <div class="header-cell">
            <el-tag v-if="scope.row.acctStat" :type="statTag[scope.row.acctStat]">
              {{acctStatEnum[scope.row.acctStat]}}
            </el-tag>
            <span v-else>-</span>
          </div>
        </template>
      </sr-tbl-column>
      <el-table-column :label="t('client.table.text_6')"
        width="230px"
        align="center"
        fixed="right">
        <template #default="scope">
          <el-button type="primary" text
          @click="handleGrowKYC(scope.row)">{{ t('client.table.text_7') }}</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <div class="empty-wrap">
          <img :src="emptyImg" alt="">
          {{t('client.content.text_2')}}
        </div>
      </template>
    </el-table>
    <sr-tbl-pagination
        v-model:current-page="tbl.pagination.currentPage"
        v-model:page-size="tbl.pagination.pageSize"
        :total="tbl.pagination.total"
        @fetchData="fetchData">
    </sr-tbl-pagination>
    <KycOptionDialog
      ref="activeRef"
      @fetchData="fetchData"></KycOptionDialog>
  </div>
</template>
<script>
import tableComp from '@/compositions/modules/table'
import SrTblColumn from '@/components/SrTblColumn'
import { components } from '@libs/ui'
import { ref, reactive } from 'vue'
import { fetchCustomer } from "@/api/modules/list"
import formComp from "@/compositions/modules/form"
import { ClientReq } from "@/domain/modules/list"
import { useI18n } from "@/plugins/i18n"
import { routeTo } from "@/utils";
import KycOptionDialog from './components/kyc-option-dialog';
import { downloadFile } from "@/utils/download";
import { list } from '@/api/url'

export default {
  components: { SrTblColumn, SrTblPagination: components.SrTblPagination, KycOptionDialog },
  setup() {
    const { t } = useI18n()
    const activeRef = ref(null)
    const { tbl, fetchData, formReq, acctStatEnum, statTag } = initTable()
    const emptyImg = ref(require('@/assets/img/dashboard/empty.png'))
    const checkAccount = (row) => {
      routeTo('/client/check-account', {
        query: {
          acctName: row.acctName,
          acctId: row.acctId,
        }
      })
    }
    const handleGrowKYC = (row) => {
      const data = {
        ...row,
      }
      activeRef.value.open(data)
    }
    const downloadList = async () => {
      await downloadFile(list.export, formReq.fields)
    }
    return { tbl, activeRef, fetchData, handleGrowKYC, emptyImg, downloadList, formReq, t, acctStatEnum, statTag, checkAccount }
  }
}

const initTable = () => {
  const { t } = useI18n()
  const { createTable } = tableComp()
  const { formReq } = initForm()
  const acctStatEnum = {
    0: t('client.content.text_3'),
    1: t('client.content.text_4'),
    2: t('client.content.text_5'),
  }
  const statTag = {
    0: 'primary',
    1: 'warning',
    2: 'dangercreateDatetime',
  }
  const columnsTemp = [
    { slot: 'acctId', align: "left", label: t('client.table.text_1') },
    { slot: "collectionAcct", align: "left", width: '100px', label: t("trade.table.text_11") },
    { prop: 'inviteCode', label: t('dashboard.table.text_7') },
    { slot: 'acctStat', label: t('client.table.text_3') },
    { prop: 'incomeDate', label: t('client.table.text_4'), width: '200px' },
    { prop: 'regDate', align: 'right', label: t('client.table.text_5'), width: '150px' },
  ]
  const tbl = createTable({ columns: columnsTemp })
  const fetchData = async () => {
    const params = {
      pageInfo: {
        current: tbl.pagination.currentPage,
        size: tbl.pagination.pageSize
      },
      acctName: formReq.fields.acctName,
      inviteCode: formReq.fields.inviteCode,
      acctId: formReq.fields.acctId,
      acctStat: formReq.fields.acctStat,
      regDate: formReq.fields.regDate,
      incomeDate: formReq.fields.incomeDate,
    }
    tbl.data.loading = true
    tbl.data.list = []
    try {
      const res = await fetchCustomer(params)
      tbl.data.list = res.list.map(item => ({ ...item, incomeDate: `${item?.incomeDate[0] || t('global.content.text_13')}~${item?.incomeDate[1] || t('global.content.text_14')}` }))
      tbl.pagination.total = res.pageInfo.total
    } finally {
      tbl.data.loading = false
    }
  }
  fetchData()
  return { tbl, fetchData, formReq, acctStatEnum, statTag }
}

// 初始化form
const initForm = () => {
  const { createForm } = formComp()
  const formReq = reactive({ ...createForm({ items: ClientReq }) })
  return { formReq }
}
</script>



<style lang="scss" scoped rel="stylesheet/scss">
  .table-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    padding: 30px 20px;

    .empty-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 160px auto;
      box-sizing: border-box;

      & > img {
        width: 190px;
        height: auto;
        display: block;
        margin-bottom: 38px;
      }
    }

    /deep/ .el-form .el-input__inner {
      width: 220px;
    }

    /deep/ .el-date-editor {
      width: 100%;
    }

    :deep(.row-con) {
      height: 57px;
    }
  }
</style>
